import { initConfetti } from 'js/lib/confetti.js'

export function initConfettiComponent() {
  const el = document.querySelector('#js-c-confetti')
  if (!el) return

  // eslint-disable-next-line no-undef
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'data-trigger' &&
        el.dataset.trigger === 'true'
      ) {
        const duration = parseInt(el.dataset.duration, 10) || 2000
        initConfetti(duration)
        el.dataset.trigger = 'false'
      }
    }
  })

  observer.observe(el, { attributes: true })
}

document.addEventListener('DOMContentLoaded', initConfettiComponent)
